import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery } from 'react-query';
import { OrganizationDto } from '../types/index';
import { OrganizationKeys } from './organization.keys';

export const getOrganization = async (id: string) => {
  const response = await clients.admin.get(`/organizations/${id}`);
  return (response.data as ApiResponse<OrganizationDto>).data;
};

export const useGetOrganization = (id: string | undefined) => {
  const definiteOrganizationId = id?.toString() ?? '';
  return useQuery(
    OrganizationKeys.detail(definiteOrganizationId),
    () => getOrganization(definiteOrganizationId),
    {
      enabled: id !== undefined,
    },
  );
};
